import { useRef, useLayoutEffect, useState, useCallback } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
export const useResizeObserver = () => {
    const [elemToObserve, setElemToObserve] = useState(null);
    const [observerEntry, setObserverEntry] = useState();
    const observer = useRef(null);
    const disconnect = useCallback(() => { var _a; return (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect(); }, []);
    const observe = useCallback(() => {
        // @ts-ignore
        observer.current = new ResizeObserver(([entry]) => setObserverEntry(entry));
        if (elemToObserve) {
            observer.current.observe(elemToObserve);
        }
    }, [elemToObserve]);
    useLayoutEffect(() => {
        observe();
        return () => disconnect();
    }, [disconnect, observe]);
    let sizeReturn = undefined;
    if (observerEntry) {
        sizeReturn = {
            width: Math.floor(observerEntry.contentRect.width),
            height: Math.floor(observerEntry.contentRect.height),
        };
    }
    ;
    return [setElemToObserve, sizeReturn];
};
//# sourceMappingURL=useResizeObserver.js.map